import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";

import { setLoading } from "app/store/tasks/slice/taskSlice";
import { setTitle } from "app/store/transmission/slice/transmissionSlice";
import { capitalize } from "lodash";

const useTasks = (selectedTab) => {
  const { isLoading } = useSelector((state) => state.task);
  const dispatch = useDispatch();

  useEffect(() => {
    isLoading && dispatch(setLoading(false));
  }, [selectedTab]);

  useEffect(() => {
    const titleMap = {
      automated: "Automated Scheduling",
      "audited-archived": "Audited Archived",
      "pending-approvals": "Pending Approvals",
    };

    const title = titleMap[selectedTab] || capitalize(selectedTab);

    dispatch(
      setTitle({
        title: `${title} Task`,
      })
    );
  }, [selectedTab]);

  return { isLoading };
};

export default useTasks;
